export default __webpack_public_path__ + "static/media/slider-1.06b970fd.jpg";